// Port of api/fuel/app/classes/controller/api/monty/listing/delete.php
import DB from 'offline/db'
import {
	currentUserId,
	loadOwnedListing,
	persist,
	unauthorised
} from './shared'

export default function(params) {
	var userId = currentUserId(params)
	var listing = loadOwnedListing(userId, params.list)
	var payload = null

	if (!userId) return unauthorised()
	if (!listing) return Promise.reject({ error: 120, offline: true })

	payload = {
		id: listing.get_id(),
		slug: listing.get_slug()
	}

	DB.run('DELETE FROM list_comment WHERE list_id = ?', [listing.get_id()])
	DB.run('DELETE FROM list_edition WHERE list_id = ?', [listing.get_id()])
	DB.run('DELETE FROM list WHERE list_id = ?', [listing.get_id()])

	return persist(payload)
}
